<template>
    <div class="progress-bar" :class="styling">
        <div class="progress-bar__value">{{ progress }}%</div>
        <progress
            max="100"
            v-bind="{ value: progress }"
            class="progress"
        />
    </div>
</template>

<script>
export default {
  name: `BaseProgressBar`,
  props: {
    progress: {
      type: Number,
      default: 0
    }
  },
  computed: {
    styling() {
      if (this.progress >= 50) {
        return "in-success";
      }
      if (this.progress >= 1) {
        return "in-progress";
      }
      return `in-start`;
    }
  }
};
</script>

<style lang="scss" scoped>

.progress-bar {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
}
.progress-bar.in-success {
  progress {
    background: rgba(10, 216, 167, 0.390951);
    border: 0;
    width: 75px;
    height: 6px;
    border-radius: 5px;
    overflow: hidden;
  }
  progress::-webkit-progress-bar {
    background: rgba(10, 216, 167, 0.390951);
  }

  progress::-webkit-progress-value {
    background: #08CE97;
    border-radius: 5px;
  }
  progress::-moz-progress-bar {
    background: rgba(10, 216, 167, 0.390951);
  }
}

.progress-bar__value {
  font-weight: 400;
  padding-top: 5px;
  font-family: ProductSans;
}

.progress-bar.in-progress {
  progress {
    background: rgba(245, 179, 38, 0.390951);
    border: 0;
    width: 75px;
    height: 6px;
    border-radius: 5px;
    overflow: hidden;
  }
  progress::-webkit-progress-bar {
    background: rgba(245, 179, 38, 0.390951);
  }
  progress::-webkit-progress-value {
    background: #f5b326;
    border-radius: 5px;
  }
  progress::-moz-progress-bar {
    background: rgba(245, 179, 38, 0.390951);
  }
}
.progress-bar.in-start {
  progress {
    background: #a0a7cd;
    border: 0;
    width: 75px;
    height: 6px;
    border-radius: 5px;
    overflow: hidden;
  }
  progress::-webkit-progress-bar {
    background: #a0a7cd;
  }
  progress::-webkit-progress-value {
    background: #fff;
    // background: map_get($colors, primary);
    border-radius: 5px;
  }
  progress::-moz-progress-bar {
    background: #a0a7cd;
  }
}
.progress-bar__value {
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  background: #fff;
  // color: map_get($colors, baseText);
}


</style>
